import { useState, useRef } from 'react'

import { Center, Spinner, Stack } from '@chakra-ui/react'

import Modal from '../../modal'
import StyledInput from '../../styled/input'
import { useRanContext } from '../../ran-state-provider'

import { userMaintenance } from '../../../lib/api-helper'

import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from '../../../lib/api-config'

const ChangeEmail = ({ onClose, setToast }) => {
  const { setAuthentication } = useRanContext()
  const [isLoading, setLoading] = useState(false)
  const [inputVal, setInputVal] = useState({
    pin: '',
    currentEmail: '',
    newEmail: ''
  })

  const recaptchaRef = useRef(null);

  const handleSubmit = async () => {
    if (isLoading) return
    setLoading(true)

    const captchaToken = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();

    const payload = {
        ...inputVal,
        captchaToken
    };

    const result = await userMaintenance('EMAIL', payload, setAuthentication)

    const onError = () => {
      setToast({
        status: 'error',
        messages: result?.errors?.length
          ? result.errors
          : ['Something went wrong']
      })
      setLoading(false)
    }

    if (result !== null || result !== undefined) {
      if (result.success) {
        setToast({
          status: 'success',
          messages: ['Email has been successfully updated!']
        })
        onClose()
      } else onError()
    } else onError()
  }

  return (
    <>
    <Modal
      header="CHANGE EMAIL"
      isOpen={true}
      isLoading={isLoading}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      {isLoading ? (
        <Center>
          <Spinner />
        </Center>
      ) : (
        <Stack spacing={3} w="full">
          <StyledInput
            value={inputVal?.pin}
            onChange={e => setInputVal({ ...inputVal, pin: e.target.value })}
            placeholder="PIN CODE"
            type="password"
          />
          <StyledInput
            value={inputVal?.currentEmail}
            onChange={e =>
              setInputVal({ ...inputVal, currentEmail: e.target.value })
            }
            placeholder="CURRENT EMAIL ADDRESS"
            type="email"
          />
          <StyledInput
            value={inputVal?.newEmail}
            onChange={e =>
              setInputVal({ ...inputVal, newEmail: e.target.value })
            }
            placeholder="NEW EMAIL ADDRESS"
            type="email"
          />
        </Stack>
      )}
    </Modal>
    <ReCAPTCHA
            sitekey={RECAPTCHA_SITE_KEY}
            size="invisible"
            ref={recaptchaRef}
        />
    </>
  )
}

export default ChangeEmail
